import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../../components/Layout';
import CategoryViewContent from '../../../components/Pages/Categories/[categoryId]';
import { CategoryByIdProvider } from '../../../components/Pages/Categories/[categoryId]/CategoryByIdProvider';

const { displayName } = config;

export default function CategoryView(): React.ReactElement {
  document.title = `${displayName}: Category View`;

  return (
    <Layout>
      <CategoryByIdProvider>
        <CategoryViewContent />
      </CategoryByIdProvider>
    </Layout>
  );
}
